import { render, staticRenderFns } from "./WhyAUMistheWrongMetricinVCJP.vue?vue&type=template&id=2db36910"
import script from "./WhyAUMistheWrongMetricinVCJP.vue?vue&type=script&lang=js"
export * from "./WhyAUMistheWrongMetricinVCJP.vue?vue&type=script&lang=js"
import style0 from "./WhyAUMistheWrongMetricinVCJP.vue?vue&type=style&index=0&id=2db36910&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports